import { render, staticRenderFns } from "./InstructorEditPage.vue?vue&type=template&id=5ed6b9b1"
import script from "./InstructorEditPage.vue?vue&type=script&lang=js"
export * from "./InstructorEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports